const colors = require('@ant-design/colors');

module.exports = {
    ...colors
}